import { get } from 'lodash'

const freeSearch = (rows = [], searchTerm = '', mapping = {}) => {
  const searchKeys = Object.keys(mapping)
  return rows.filter(row => {
    return Object.keys(row).some(key => {
      if (!searchKeys.includes(key)) return false
      let searchPath = mapping[key]
      let searchValue = get(row, searchPath)
      return searchValue
        ? searchValue
            .toString()
            .toLowerCase()
            .trim()
            .includes(searchTerm.toLowerCase().trim())
        : false
    })
  })
}

export { freeSearch }
